<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-回访-添加
    -->
    <el-dialog
    title="修改"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改</div>

   
    

      <el-form-item label="设置比例" prop="rate">
        <el-input v-model="form.rate" placeholder="设置比例" class="max-w460"></el-input>
      </el-form-item>

      <!-- <el-form-item label="状态" prop="status">
      <div >
          <el-radio-group v-model="form.status">
            <el-radio  :label="1" >启用</el-radio>
            <el-radio  :label="0" >停用</el-radio>
          </el-radio-group>
      </div>
      </el-form-item>
       -->


    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</el-dialog>
  
</template>

<script>
import EquipApi from '@/api/equip.js';
import Getpoint from '@/components/map/Getpoint.vue';
export default {
  components: {
    Getpoint
  },
  data() {
    return {

      /*form表单数据*/
      form: {
        rate:""

      },
      loading: false,
      /*验证规则*/
      rules: {
        rate: [{ required: true, message: '请输入设备比例', trigger: 'blur' }]

      },
      dialogVisible:false,
      equip_id:0,
        equip_info:{

        },
      service_id:0,
       service_info:{

        },
        open_add_serivce:false,
        open_add_equip:false,


        open_choose_filiale:false,
        open_choose_service:false,


        excludeIdsFiliale:[],
        excludeIdsService:[],
        excludeIdsEquip:[],
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();

  },
  props: ["open_add","equip_belong_id"],
  methods: {

    getServiceUserById(){
      var self = this;
      EquipApi.getServiceUserById({
        service_id:self.service_id_t
      }, true)
            .then(data => {
              if(data.data.service_id){
                  self.open_choose_service= true
                  self.form.service_id =    data.data.service_id;   
                  self.service_info = data.data
              }
    
      });
    },

      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;

      },
       /*获取经纬度*/
       getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      EquipApi.ebdetail({equip_belong_id: self.equip_belong_id},true).then(res => {
          self.form = res.data;
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.equip_belong_id = self.equip_belong_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          EquipApi.edit_belong(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/equip/equip/belong/edit.vue